export default __webpack_public_path__ + "static/media/tile-2-long.231ca844.png";